// extracted by mini-css-extract-plugin
module.exports = {"sixTwelveMonthsConditionsFootnote":"Footnote_sixTwelveMonthsConditionsFootnote__1J5Vu","hiddenContent":"Footnote_hiddenContent__xkHNp"};